import Router from 'vue-router'
import Vue from 'vue'
import Errors from './view/error'
import util from './common/util.js'

Vue.use(Router)

const routes = [
  {
    path: '/',
    name: '/',
    redirect: '/',
    component: () => import(/* webpackChunkName: "main" */ './view/pages/main.vue'),
    meta: {
      title: '主页'
    },
    children: [
      {
        path: '/',
        component: () => import(/* webpackChunkName: "home" */ './view/pages/home.vue'),
        meta: {
          title: ''
        }
      },
      {
        path: 'story/:id',
        component: () => import(/* webpackChunkName: "story" */ './view/pages/home/story.vue'),
        meta: {
          title: '客户详情'
        }
      },
      {
        path: 'customerCase',
        component: () => import(/* webpackChunkName: "story" */ './view/pages/customerCase/index.vue'),
        meta: {
          title: '客户案例'
        }
      },
      {
        path: 'join',
        component: () => import(/* webpackChunkName: "join" */ './view/pages/join/join.vue'),
        meta: {
          title: '加入我们'
        }
      },
      {
        path: 'job',
        component: () => import(/* webpackChunkName: "job" */ './view/pages/join/job.vue'),
        meta: {
          title: '全部职位'
        }
      },
      {
        path: 'job/detail/:pid',
        component: () => import(/* webpackChunkName: "jobDetail" */ './view/pages/join/jobDetail.vue'),
        meta: {
          title: '职位详情'
        }
      },
      {
        path: 'esmartDetail',
        component: () => import(/* webpackChunkName: "esmartDetail" */ './view/pages/home/esmartDetail.vue'),
        meta: {
          title: '金关之星介绍'
        }
      },
      {
        path: 'newCcbaDetail',
        component: () => import(/* webpackChunkName: "esmartDetail" */ './view/pages/home/newCcbaDetail.vue'),
        meta: {
          title: 'CCBA介绍'
        }
      },
      {
        path: 'newSaiDetail',
        component: () => import(/* webpackChunkName: "esmartDetail" */ './view/pages/home/newSaiDetail.vue'),
        meta: {
          title: '赛吉斯介绍'
        }
      },
      {
        path: 'services/:id',
        component: () => import(/* webpackChunkName: "addService" */ './view/pages/home/addService.vue'),
        meta: {
          title: '增值服务'
        }
      },
      {
        path: 'about',
        component: () => import(/* webpackChunkName: "aboutUs" */ './view/pages/home/aboutUs.vue'),
        meta: {
          title: '关于我们'
        }
      },
      {
        path: 'news',
        component: () => import(/* webpackChunkName: "news" */ './view/pages/news/news.vue'),
        meta: {
          title: '新闻资讯'
        }
      },
      {
        name: 'newsDetail',
        path: 'news/detail/:pid',
        component: () => import(/* webpackChunkName: "detail" */ './view/pages/news/detail.vue'),
        meta: {
          title: '新闻详情'
        }
      },
      {
        path: 'thAdvantage',
        component: () => import(/* webpackChunkName: "story" */ './view/pages/thAdvantage/index.vue'),
        meta: {
          title: '技术优势'
        }
      },
      {
        path: 'feima',
        component: () => import(/* webpackChunkName: "feima" */ './view/pages/feima.vue'),
        meta: {
          title: '飞蚂制单'
        }
      },
      {
        path: 'customs',
        component: () => import(/* webpackChunkName: "customs" */ './view/pages/home/customs.vue'),
        meta: {
          title: '海关口岸'
        }
      },
      {
        path: 'links',
        component: () => import(/* webpackChunkName: "links" */ './view/pages/newDetail/links.vue'),
        meta: {
          title: '跨境易联'
        }
      },
      {
        path: 'woodPecker',
        component: () => import(/* webpackChunkName: "woodPecker" */ './view/pages/newDetail/woodPecker.vue'),
        meta: {
          title: '啄木鸟'
        }
      }
    ]
  },
  Errors.MENU
]
const router = new Router({
  mode: 'history',
  base: process.env.NODE_ENV !== 'production' ? 'www' : '',
  routes, // (缩写) 相当于 routes: routes
  scrollBehavior (to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash
      }
    } else if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  if (from.fullPath !== '/') {
    window.sessionStorage.setItem('router', from.fullPath)
  }
  if (!util.isEmpty(to.query.callback)) {
    window.sessionStorage.setItem('callback', to.query.callback)
  }
  if (!util.isEmpty(to.query.token)) {
    window.localStorage.setItem('token', to.query.token)
  }
  if (to.path === '/error/404' || to.path === '/error/500' || to.path === '/error/wait') {
    next()
  } else if (to.path === '/login') {
    if (window.parent === window.self) {
      next()
    } else {
      window.parent.postMessage({ type: 'login' }, '*')
    }
  } else {
    next()
  }
})

router.afterEach(route => {
  // 路径跳转后替换页面title
  let title = route.meta.title ? '-' + route.meta.title : ''
  document.title = '朗新一诺官网' + title
  document.body.scrollTop = 0
  let path = route.fullPath
  if (path === '/error/404' || path === '/error/500' || path === '/error/wait') {
    return false
  }
})
export default router
